import './App.css';
import Email from './components/Email';
import Footer from './components/Footer';
import Main from './components/Main';
import Navmain from './components/Navmain';
import Race from './components/Race';
// import {slide as Slider} from 'react-burger-menu'


function App() {
  return (
    <div className="App">

      <div className="css-1vzpfxd">
        <Navmain />
        <Main />
        <Race />
        <Email />
        <Footer />
      </div>

    </div>
  );
}
export default App;